import React, { useEffect } from 'react'
import Slider from '../Slider/Slider'
import UmrahPackages from '../HomePackageSlider/Umrah_package'
import WhyOnlineUmrah from '../WhyOnlineUmrah/Online_umrah'

const Homepage = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
 
    return (
        <>
            <Slider />
            <UmrahPackages />
            <WhyOnlineUmrah />
        </>
    )
}

export default Homepage
